import React, { useContext } from "react"
import { Grid } from "@material-ui/core"
import QuarterlyPostPurchCard from "../components/QuarterlyPostPurchCard"
import ProductAllocationCard from "../components/ProductAllocationCard"
import ReferenceTablesCard from "../components/ReferenceTablesCard"
import ActivityFeedCard from "../components/ActivityFeedCard"
import { HistoryContext } from "../contexts/HistoryContext"
import { UserContext } from "../contexts/UserContext"

const UploadsPage = () => {
  const { fetchHistory, history, historyLoading, historyError } = useContext(
    HistoryContext
  )
  const { user } = useContext(UserContext)

  const reload = () => {
    fetchHistory(user)
  }

  const uploadHistory = history.filter(
    (item) =>
      item.activity_type_id === 1 ||
      (item.activity_type_id === 2 && item.context !== "megafile") ||
      item.activity_type_id === 8 ||
      item.activity_type_id === 10 ||
      item.activity_type_id === 11
  )

  return (
    <Grid container>
      <Grid md={6}>
        <Grid md={10}>
          <QuarterlyPostPurchCard />
          <ProductAllocationCard />
          <ReferenceTablesCard />
          {/*user.accessLevel === "ADMIN" && <QuarterlyPostPurchCard />*/}
        </Grid>
      </Grid>
      <Grid md={6}>
        <Grid md={10}>
          <ActivityFeedCard
            title="Upload Activity"
            activities={uploadHistory}
            loading={historyLoading}
            error={historyError}
            refreshHistory={reload}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default UploadsPage
